import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import { Abbreviation } from "../../../../../../../models/abbreviation";
import { AbbreviationControllerService } from "../../../../../../../services/form-controller/abbreviation-controller.service";
import {BaseError} from "../../../../../base-error";

@Component({
  selector: "field-set-abbreviation",
  templateUrl: "./field-set-abbreviation.component.html",
  styles: [],
  providers: [AbbreviationControllerService],
})
export class FieldSetAbbreviationComponent extends BaseError implements OnInit {

  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();
  public abbreviationItems: Abbreviation[] = [];

  constructor(private abbreviationController: AbbreviationControllerService, toastr: ToastrService) {
    super(toastr);
  }

  public ngOnInit() {
    this.loadAllAbbreviations();
  }

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }

  public loadAllAbbreviations() {
    this.abbreviationController.getAbbreviationList().subscribe(
      (data) => this.abbreviationItems = data,
    );
  }

  public onAbbreviationAdded(abbreviation: Abbreviation) {
    if (abbreviation.id === abbreviation.name) {
      abbreviation.id = undefined;
    }
    if (abbreviation.id === undefined) {
      this.abbreviationController.createAbbreviation(abbreviation).subscribe(
        (data) => {
          abbreviation = data;
        },
        (error) => this.showErrorMessage(error),
      );
    }
  }

}
